// src/utils/fetchSchoolYears.js
import http from "../api/apiClient";
import { parseToDate } from "./dateUtils";

/**
 * Haal alle schooljaren op
 * @returns {Promise<Array>} lijst van schooljaren
 */
export const fetchSchoolYears = async () => {
  try {
    const { data } = await http.get("/years");
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("❌ Error fetching school years:", error);
    throw error;
  }
};

/**
 * Haal het huidige schooljaar op, gebaseerd op de datum van vandaag
 * @returns {Promise<Object|null>} huidig schooljaar of null
 */
export const fetchCurrentSchoolYear = async () => {
  try {
    const years = await fetchSchoolYears();
    const today = new Date();

    return (
      years.find((year) => {
        const start = parseToDate(year.startDate);
        const end = parseToDate(year.endDate);
        if (!start || !end) return false;
        return today >= start && today <= end;
      }) || null
    );
  } catch (err) {
    console.error("❌ Failed to fetch current school year:", err);
    throw err;
  }
};
